import {inject, injectable} from 'inversify';

import type {FileModel} from '../../domain/File/File.model';

import {logger} from '../../../utils/logger';
import {UploadFileCmd} from '../../ports/File/UploadFile/UploadFile.cmd';

@injectable()
export class UploadFileUseCase {
  constructor(@inject(UploadFileCmd) private readonly cmd: UploadFileCmd) {}

  async exec(props: UploadFileUseCase.Props): Promise<FileModel> {
    try {
      return await this.cmd.exec(props);
    } catch (e) {
      logger.error(e);

      throw e;
    }
  }
}

export namespace UploadFileUseCase {
  export type Props = UploadFileCmd.Props;
}
